import React from 'react';
import LoginTemplate from '../../components/login/LoginTemplate';
import LoginFormContainer from '../../containers/login/LoginFormContainer';

const LoginPage = () => {

  return (
    <LoginTemplate>
      <LoginFormContainer />
    </LoginTemplate>
  );
};

export default LoginPage;
